import BlogContent from './BlogContent'
import BlogOther from './BlogOther'

export default function BlogDetail() {
  return (
    <>
     <BlogContent/> 
     <BlogOther/>
    </>
  )
}
